
import { AppService } from "app/services/app.service";
export abstract class AbTipoRecurso extends AppService {
  abstract prefixo: string;
  abstract getAllAtivos();
}